import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { NSC_URN_OPERATIONS } from '@/constants';
import { useSearchParams } from '@/hooks';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';

export default function StakingEngineActivityPage() {
  const ilk = 'LSEV2-SKY-A';
  const [daysAgo] = useSearchParams('days_ago', '1');

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(NSC_URN_OPERATIONS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [filters]);

  const [data, error] = useApi({
    url: `/groups/staked/ilks/${ilk}/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="4"
              />
            }>
            <Heading size="1">{data.ilk} Activity</Heading>
          </EntityName>
        }>
        <HistoricTabs ilk={ilk} />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>
        <EventsTable
          collateralSymbol={data.collateral_symbol}
          collateralAddress={data.collateral_address}
          pagination={pagination}
          sorting={sorting}
          filters={filters}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
